import { Link } from 'react-router-dom';
import { SignupForm } from 'features/auth/components/signup-form';
import { useGetLoginOptions } from 'features/auth/hooks/use-auth';
import { GRANT_TYPES } from 'constant/auth';
import { SsoSignin } from '../signin/signin-sso';
import { useTranslation } from 'react-i18next';
import { AuthBrand } from '../shared/auth-brand';

export function SignupPage() {
  const { data: loginOption } = useGetLoginOptions();
  const socialGrantAllowed = loginOption?.allowedGrantTypes?.includes(GRANT_TYPES.social);

  return (
    <div className="flex w-full max-w-[456px] flex-col gap-6">
      <AuthBrand />
      <SignupHeader />
      <div className="mt-2 flex w-full flex-col gap-6">
        <SignupForm />
        {socialGrantAllowed && loginOption && <SsoSignin loginOption={loginOption} />}
      </div>
    </div>
  );
}

function SignupHeader() {
  const { t } = useTranslation();

  return (
    <div>
      <h2 className="text-2xl font-bold text-high-emphasis">{t('SIGN_UP')}</h2>
      <div className="mt-1 flex items-center gap-1">
        <span className="text-sm font-normal text-medium-emphasis">
          {t('ALREADY_HAVE_ACCOUNT')}
        </span>
        <Link
          to={'/login'}
          className="text-sm font-bold text-primary hover:text-primary-600 hover:underline"
        >
          {t('LOG_IN')}
        </Link>
      </div>
    </div>
  );
}
